/* External dependencies */
import { filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../clients/demirbank';
import { listServicesFailed, listServicesSucceeded } from './actions';
import { listServicesQuery } from './queries';
import { ListServices, ListServicesAction, ListServicesActionTypes, ListServicesSuccess } from './types';

export default function listServicesEpic(action$, state$) {
  return action$.pipe(
    filter((action: ListServicesAction) => action.type === ListServicesActionTypes.LIST_SERVICES_REQUEST),
    switchMap((action: ListServices) =>
      listServices(action, state$.value.services.size).catch((error) => listServicesFailed(error)),
    ),
  );
}

export async function listServices(
  { filter, currentPage, searchString }: ListServices,
  size: number,
): Promise<ListServicesSuccess> {
  const graphQLClient = await getClient();

  const input = {
    from: (currentPage - 1) * size,
    query: searchString,
    size,
    filter,
  };

  input.filter.tags = filter?.tags?.filter((item) => item);

  if (!input.filter?.tags?.length) {
    input.filter.tags = undefined;
  }

  const {
    data: {
      listServices: { services, total },
    },
  } = await graphQLClient.query({
    query: listServicesQuery,
    variables: {
      input,
    },
  });

  return listServicesSucceeded(total, services);
}
